import { LitElement, html, css } from 'lit';
import { customElement, property, query } from 'lit/decorators.js';
import type { ReportListItem } from '../types/report';

@customElement('bia-report-selector')
export class BiaReportSelector extends LitElement {
  static styles = css`
    :host { display: block; }
    select {
      width: 100%;
      padding: 6px 8px;
      border: 1px solid var(--bia-border, #E0E0E0);
      border-radius: 8px;
      font-family: var(--bia-font-family, sans-serif);
      background: var(--bia-background, #fff);
      color: var(--bia-text, #212121);
    }
  `;

  @property({ type: Array }) reports: ReportListItem[] = [];
  @property({ type: Number }) selectedId: number | null = null;

  @query('select') private selectEl!: HTMLSelectElement;

  updated(): void {
    if (this.selectEl) {
      this.selectEl.value = String(this.selectedId ?? '');
    }
  }

  private onChange(event: Event): void {
    const value = (event.target as HTMLSelectElement).value;
    const id = Number(value);
    const found = this.reports.find((r) => r.id === id);
    if (!found) return;
    this.dispatchEvent(
      new CustomEvent<ReportListItem>('select', {
        detail: found,
        bubbles: true,
        composed: true,
      }),
    );
  }

  render() {
    return html`
      <select @change=${this.onChange}>
        <option value="" ?selected=${this.selectedId == null}>Selecione um relatório...</option>
        ${this.reports.map(
          (r) => html`<option value=${r.id} ?selected=${r.id === this.selectedId}>${r.nome}</option>`,
        )}
      </select>
    `;
  }
}
